import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './styles.scss';
import Timer from 'react-compound-timer/build';

export default function Counter(props) {

  return (
    <Timer initialTime={props.initialTime} direction="backward"
      checkpoints={[
        {
          time: 1,
          callback: () => {
            props.callback()
          },
        },
      ]}>
      {() => (
        <div className="timer">
          <table>
            <tbody>
              <tr>
                <td>
                  <div id="days">
                    <Timer.Days />
                  </div>
                  <span className="info">DAYS</span>
                </td>
                <td>
                  <div id="hours">
                    <Timer.Hours />
                  </div>
                  <span className="info">HRS</span>
                </td>
                <td>
                  <div id="minutes">
                    <Timer.Minutes />
                  </div>
                  <span className="info">MNS</span>
                </td>
                <td>
                  <div id="seconds" className="sec">
                    <Timer.Seconds />
                  </div>
                  <span className="info">SECS</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </Timer>
  );
}
Counter.propTypes = {
  initialTime: PropTypes.number,
  callback: PropTypes.func
};
